import type { AppConfig } from "../config";

export default function Landing({
  config: _config,
}: {
  config: AppConfig;
  // Old signature accepts contractOwner; App.tsx still passes it.
  contractOwner?: string;
}) {
  return (
    <div className="landing-bg">
      <div className="main">
        <section className="hero">
          <h1>Liquidity desk for staked positions</h1>
          <p className="lead">
            Swap staked Meta-ESDT positions for the free fungible token through
            owner- or community-run pools, with a fixed per-pool discount and a
            single platform fee.
          </p>
          <p className="muted" style={{ fontSize: "0.9rem" }}>
            Connect a wallet from the top right to view pools, run quotes, or
            spin up your own pool.
          </p>
        </section>

        <div className="grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
          <div className="card">
            <h3>Pools, your way</h3>
            <p className="muted">
              Owner runs pools on any pair; the community runs pools on public
              pairs — one pool per address per pair.
            </p>
          </div>
          <div className="card">
            <h3>Fixed discounts</h3>
            <p className="muted">
              A pool's discount is immutable. To change it, the creator closes
              the pool and opens a new one — no bait-and-switch.
            </p>
          </div>
          <div className="card">
            <h3>Transparent split</h3>
            <p className="muted">
              Every quote breaks down how much goes to you, the pool, and the
              platform fee. No surprises.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
